document.addEventListener('DOMContentLoaded', function() {
  AOS.init({
    once: true,
    offset: 0
  });
});
